<template>
  <div class="guest-experiences-container">
    <v-tabs v-model="activeTab"
            background-color="#587e27"
            color="white"
            slider-color="green"
            grow
            class="experiences-tabs">
      <v-tab>
        Activities
      </v-tab>
      <v-tab>
        Accommodation
      </v-tab>
      <v-tab>
        Camping
      </v-tab>

      <v-tab-item>
        <v-card flat>
          <activities></activities>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <accomodations></accomodations>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <v-card flat>
          <camp-sites></camp-sites>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
  import Activities from '@/views/Back/Guests/Activities.vue'
  import Accomodations from '@/views/Back/Guests/Accomodation.vue'
  import CampSites from '@/views/Back/Guests/CampSites.vue'

  export default {
    name: 'GuestExperiences',
    components: {
      Activities,
      Accomodations,
      CampSites
    },
    data() {
      return {
        activeTab: null
      }
    }
  }
</script>

<style scoped>
  .guest-experiences-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }

  .experiences-tabs {
    margin-bottom: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
    /* Make tabs consistent in height */
    .experiences-tabs > > > .v-tab {
      min-height: 64px;
      text-transform: none;
      font-weight: 500;
      font-size: 16px;
      color: white !important;
    }
    /* Tab content styling */
    .experiences-tabs > > > .v-tab-item .v-card {
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      min-height: 400px;
    }
    /* Active tab styling - keep text white */
    .experiences-tabs > > > .v-tab--active {
      color: white !important;
      font-weight: 600;
    }
    /* Hover effects */
    .experiences-tabs > > > .v-tab:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }

  @media (max-width: 960px) {
    .guest-experiences-container {
      padding: 10px;
    }

    .experiences-tabs > > > .v-tab {
      min-height: 52px;
      font-size: 14px;
    }
  }

  @media (max-width: 600px) {
    .guest-experiences-container {
      padding: 10px;
    }
    /* Stack tabs on mobile if needed */
    .experiences-tabs > > > .v-slide-group__wrapper {
      overflow-x: auto;
    }
  }
</style>
